module.exports = __webpack_public_path__ + "static/media/road4.895bd430.png";